import { httpClient } from "./client";
import type { AnalyticsApi } from "./interfaces";
import type { PlayerProfileStatsResponse } from "../types";

export const analyticsApi: AnalyticsApi = {
  getPlayerProfile: (userId: string) =>
    httpClient.get<PlayerProfileStatsResponse>(`/analytics/players/${encodeURIComponent(userId)}/profile`),
};
